import { render, staticRenderFns } from "./headerBack.vue?vue&type=template&id=2b682924&scoped=true&"
import script from "./headerBack.vue?vue&type=script&lang=js&"
export * from "./headerBack.vue?vue&type=script&lang=js&"
import style0 from "./headerBack.vue?vue&type=style&index=0&id=2b682924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b682924",
  null
  
)

export default component.exports